export default __webpack_public_path__ + "static/media/auto.d775fc61.svg";